export class Symptoms {
    static moduleName = 'symptoms';
    static moduleEntityName = 'symptomsEntity';
    static listTitle = 'Справочник симптомов';
    static createTitle = 'Добавление нового симптома';
    static apiPrefix = 'symptoms';
}